<iframe [src]="sanitizedPdfLink" width="100%" height="100%"></iframe>